import { casaCampanaApi } from '@/core/config'
import { errorHandler } from '@/core/utils/axiosErrorHandler'

const HomeServices = {
  async getCategorys(url = '') {
    try {
      const data = await casaCampanaApi.get('/public/ecommerce/category' + url)
      return data
    } catch (err) {
      const error = errorHandler('Error en el getCategorys')
      throw new Error(error.message)
    }
  },
  async getProducts(url = '') {
    try {
      const { data } = await casaCampanaApi.get('/public/ecommerce' + url)
      return data
    } catch (err) {
      const error = errorHandler('Error en el getProducts')
      throw new Error(error.message)
    }
  },
}

export default HomeServices